import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SelectOptions } from '@usitsdasdesign/dds-ng/select';
import { LabelPosition, Size } from '@usitsdasdesign/dds-ng/shared';
import { Item } from 'src/app/models/masterdata.model';
import { DataContextService } from 'src/app/services/datacontext.service';

@Component({
  selector: 'app-data-table-search',
  templateUrl: './data-table-search.component.html',
  styleUrls: ['./data-table-search.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTableSearchComponent implements OnInit {
  @Input() placeholder = 'Translation.Searchby';
  @Input() limit = 3;
  @Input() refreshDataEmitter: boolean;
  @Input() formSearchValue: any = null;

  @Output() searchChanged = new EventEmitter<string>();
  @Output() searchAcrossAllLocations = new EventEmitter<boolean>();
  @Output() searchAcrossAllLocationsForm = new EventEmitter<any>();

  @Input() searchValue = '';
  @Input() initSearchVal = '';

  @Input() isAcrossAllLocations: boolean = false;
  isStandardSearchActive = true;
  series: Item[] = [];

  selectOptions: SelectOptions = {
    label: 'Series',
    labelPosition: LabelPosition.external,
    placeholder: 'Select',
    size: Size.md,
    isDisabled: false,
    isRequired: false,
  };

  selectedItem: string;

  form = new FormGroup({
    meetingName: new FormControl(''),
    series: new FormControl(''),
  });

  standardSearchInitiated: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.searchValue = this.searchValue ? this.searchValue : this.initSearchVal;
    if (this.isAcrossAllLocations) {
      this.isStandardSearchActive = !this.isAcrossAllLocations;
    }
    this.series = DataContextService.Series;
    if (this.formSearchValue) {
      this.form.setValue(this.formSearchValue);
    }
  }

  clearInput(): void {
    this.searchValue = '';
    this.cdRef.detectChanges();
    this.searchChanged.emit('');
  }

  clearSearchInput(): void {
    this.form.get('meetingName').setValue('');
  }

  onSearchValueChange(value: string): void {
    if(value.length >= this.limit) {
      this.standardSearchInitiated = true;
      this.searchChanged.emit(value);
    }
    else if(value.length == 0 && this.standardSearchInitiated) {
      this.standardSearchInitiated = false;
      this.searchChanged.emit('');
    };
  };

  standardSeacrhActivated(): void {
    this.isStandardSearchActive = true;
    this.searchAcrossAllLocations.emit(!this.isStandardSearchActive);
    this.clearSearchInput();
    this.searchChanged.emit('');
    this.form.get('series').reset();
  }

  searchAcrossAllLocationsActivated(): void {
    this.isStandardSearchActive = false;
    this.searchValue = '';
    this.cdRef.detectChanges();
    this.searchChanged.emit('');
    this.searchAcrossAllLocations.emit(!this.isStandardSearchActive);
  }

  onApplyFilters(): void {
    this.searchAcrossAllLocationsForm.emit(this.form.value);
  }

  get isFormApplyEnabled(): boolean {
    return !!this.form.get('meetingName').value.length || !!this.form.get('series').value;
  }
}
